export const APPLY_TEMPLATE_FETCH_COUNT = 100